// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据标签查询内容
export const selectMessage = (id) => {
  return request.post('/department/select/id', id)
}

// 根据标签查询内容
export const selectDepartment = (tag, currentPage, pageSize) => {
  return request.post('/department/select/tag', tag, {
    params: {
      tag: tag,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
